<!--
 * @Author: your name
 * @Date: 2022-03-15 15:56:05
 * @LastEditTime: 2022-03-30 19:52:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\Organization.vue
-->
<template>
  <div class="organization">
    <div class="organization-all">
      <div>
        <div class="Technology-organization">
          <p>{{ $t("Technology.organization") }}</p>
        </div>
        <div class="DAO-organization">
          <p>{{ $t("DAOorganization.organization") }}</p>
        </div>
        <div class="business-organization">
          {{ $t("DAOorganization.business") }}
        </div>
        <div>
          <ul>
            <li class="Various-li">
              <p class="Various-from">
                <span class="Various-dian"></span
                >{{ $t("DAOorganization.Various") }}
              </p>
              <p class="Various-from-p">
                {{ $t("DAOorganization.Encryption") }}
              </p>
              <p class="Various-from-p">{{ $t("DAOorganization.Grants") }}</p>
              <p class="Various-from-p">
                {{ $t("DAOorganization.Investment") }}
              </p>
              <p class="Various-from-p">
                {{ $t("DAOorganization.Collecting") }}
              </p>
            </li>
            <li class="Various-li2">
              <p class="Various-from">
                <span class="Various-dian Various-dian2"></span>
                {{ $t("DAOorganization.Advantages") }}
              </p>
              <p class="Various-from-p Various-from-p2">
                {{ $t("DAOorganization.Hightransparency") }}
              </p>
              <p class="Various-from-p Various-from-p2">
                {{ $t("DAOorganization.Inspire") }}
              </p>
              <p class="Various-from-p Various-from-p2">
                {{ $t("DAOorganization.Inexpensive") }}
              </p>
              <p class="Various-from-p Various-from-p2">
                {{ $t("DAOorganization.Strong") }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
span {
  display: inline-block;
}
.organization {
  background: url(../../../assets/pc/intro/back.png) no-repeat center / 100%
    100%;
    background-size: 100%;
  // background-position: 0 200px;
  padding: 231px 0 319px 10px;
}
.organization-all {
  width: 1200px;
  margin: 0 auto;

  .Technology-organization {
    font-size: 80px;
    font-weight: 900;
    color: #000;
    line-height: 102.2px;
    text-align: left;
    font-family: Poppins-Black, Poppins;
    -webkit-background-clip: text;
  }
  .DAO-organization {
    font-size: 24px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
    -webkit-background-clip: text;
    margin: 25px 0 22px 0;
    margin-top: 45px;
  }
  .business-organization {
    font-size: 18px;
    color: #61666b;
    line-height: 29.7px;
    margin-bottom: 90px;
    margin-top: 22px;
  }
  ul {
    list-style: none;
    padding-left: 0;
    .Various-li {
      margin-bottom: 90px;
    }
    .Various-li2 {
      // margin-bottom: 319px;
    }
    li {
      .Various-from {
        font-size: 18px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #2c1d1a;
        line-height: 31px;
        -webkit-background-clip: text;
        margin-bottom: 15px;
      }
      .Various-from-p {
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #737582;
        line-height: 24px;
        -webkit-background-clip: text;
        margin-left: 20px;
        margin-bottom: 15px;
      }
      .Various-from-p2{
        margin-left: 23px;
      }
      .Various-dian {
        width: 7px;
        height: 7px;
        background-color: #000;
        border-radius: 2px;
        margin: 0 12px 4px 0;
      }
      .Various-dian2 {
        background-color: #4573e7;
      }
    }
  }
}
</style>
